export { default } from './loader-screen'
